import { render } from "./Table.vue?vue&type=template&id=2466f07c&ts=true"
import script from "./Table.vue?vue&type=script&lang=ts&setup=true"
export * from "./Table.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/Plots/Fertilizations/Table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2466f07c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2466f07c', __exports__)) {
    console.log('reload')
    api.reload('2466f07c', __exports__)
  }
  
  module.hot.accept("./Table.vue?vue&type=template&id=2466f07c&ts=true", () => {
    console.log('re-render')
    api.rerender('2466f07c', render)
  })

}


export default __exports__